import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconNumberedList = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 24,
	height: 24,
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M4 24h9.028v-1.705h-3.31v-14.295h-1.58c-0.878 0.527-1.931 0.928-3.386 1.179v1.329h2.909v11.787h-3.661v1.705zM16.667 10h10.667c0.368 0 0.667 0.298 0.667 0.667s-0.298 0.667-0.667 0.667h-10.667c-0.368 0-0.667-0.298-0.667-0.667s0.298-0.667 0.667-0.667zM16.667 15.333h10.667c0.368 0 0.667 0.298 0.667 0.667s-0.298 0.667-0.667 0.667h-10.667c-0.368 0-0.667-0.298-0.667-0.667s0.298-0.667 0.667-0.667zM16.667 20.667h10.667c0.368 0 0.667 0.298 0.667 0.667s-0.298 0.667-0.667 0.667h-10.667c-0.368 0-0.667-0.298-0.667-0.667s0.298-0.667 0.667-0.667z"
	})
});
export { SvgIconNumberedList as ReactComponent };
